import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWheelPrizes, postWheelSpin } from "./wheel.service";
import { WheelPrizesData, WheelSpinData } from "./wheel.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";
import { handleApiError } from "@/app/utils/handleApiError";

export const getWheelPrizes = createAsyncThunk<
  WheelPrizesData,
  void,
  RejectValueType & { state: RootState }
>(
  "wheel/getWheelPrizes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchWheelPrizes();
      return response.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { wheel } = getState();
      if (wheel.prizes.status === "loading") return false;
      return true;
    },
  },
);

export const spinWheel = createAsyncThunk<
  WheelSpinData,
  void,
  RejectValueType & { state: RootState }
>(
  "wheel/spinWheel",
  async (_, { rejectWithValue }) => {
    try {
      const response = await postWheelSpin();
      return { ...response.data, message: response.message ?? "" };
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { wheel } = getState();
      if (wheel.spin.status === "loading") return false;
      if (wheel.spin.data) return false;
      return true;
    },
  },
);
